import React from 'react';
import { LinearGradient } from 'tamagui/linear-gradient';

import { CobuCard, CobuStack, CobuText } from '@cobu/ui';
import { RankingIcon } from '../../assets/icons/ReferralIcons';

interface ResultCardProps {
  heading: string;
  subHeading: string;
  gradientColors: [string, string, ...string[]];
  onPress: () => void;
  iconComponent?: React.ReactNode;
}

export const ResultCard: React.FC<ResultCardProps> = ({
  heading,
  subHeading,
  gradientColors,
  onPress,
  iconComponent,
}) => {
  return (
    <CobuCard 
      elevation={0.4}
      br="$2"
      p="$0"
      bg="$white"
      ov="hidden"
      onPress={onPress as any}
    >
      <CobuStack layout="horizontal" f={1} ai="stretch">
        <CobuStack style={gradientContainer as any}>
          <LinearGradient
            colors={gradientColors}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{ position: 'absolute', inset: 0, zIndex: 0 }}
          />
          <CobuStack f={1} ai="center" jc="center" zIndex={1}>
            {iconComponent}
          </CobuStack>
        </CobuStack>
        
        <CobuStack f={1} py="$2" pl="$3" pr="$3" jc="center" ai="flex-start" gap="$2">
          <CobuText 
            variant="body" 
            fontSize="$4" 
            fontWeight="medium" 
          >
            {heading}
          </CobuText>
          
          <CobuText 
            variant="body" 
            fontSize="$3" 
          >
            {subHeading}
          </CobuText>
        </CobuStack>
      </CobuStack>
    </CobuCard>
  );
};

const gradientContainer = {
  width: 72,
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'stretch',
  position: 'relative' as const,
  overflow: 'hidden' as const,
};